import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import Button from '../button';
import { dataHooks } from './constants.js';

var makeButton = function makeButton(section, sectionIndex, option, optionIndex) {
  return /*#__PURE__*/React.createElement(Button, {
    key: option + optionIndex,
    className: "btn-thumbnail",
    disabled: option.disabled,
    onClick: option.onClick,
    dataHook: dataHooks.buttonThumbnail(optionIndex)
  }, option.illustration);
};

var makeThumbnails = function makeThumbnails(sections, sectionIndex) {
  return /*#__PURE__*/React.createElement("div", {
    className: "thumbnail-buttons-section",
    key: "section".concat(sectionIndex)
  }, sections.map(function (option, optionIndex) {
    return makeButton(sections, sectionIndex, option, optionIndex);
  }));
};

var ThumbnailButtonGroup = function ThumbnailButtonGroup(_ref) {
  var getClassName = _ref.getClassName,
      automationId = _ref.automationId,
      dataHook = _ref.dataHook,
      maxThumbsPerRow = _ref.maxThumbsPerRow,
      numOfThumbsThatForceBreak = _ref.numOfThumbsThatForceBreak,
      options = _ref.options;
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName('control-thumbnail-button-group'),
    "data-aid": automationId,
    "data-hook": dataHook,
    "data-max-items-per-row": maxThumbsPerRow
  }, (numOfThumbsThatForceBreak ? _.chunk(options, numOfThumbsThatForceBreak) : [options]).map(makeThumbnails));
};

ThumbnailButtonGroup.displayName = 'ThumbnailButtonGroup';
ThumbnailButtonGroup.propTypes = {
  /** List of thumbnails object to display */
  options: PropTypes.arrayOf(PropTypes.shape({
    illustration: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  })).isRequired,

  /** Maximum number of thumbnails to display per row */
  maxThumbsPerRow: PropTypes.number.isRequired,

  /** Number of thumbnails that force break in line */
  numOfThumbsThatForceBreak: PropTypes.number
};
export default compose(ThumbnailButtonGroup);